Ext.ns('mx.plugin');

mx.plugin.persistentFilterPlugin = function(config) {
    Ext.apply(this, config);
};
Ext.extend(mx.plugin.persistentFilterPlugin, Ext.util.Observable, {
    filterKey: null,
    onFilterLoaded: Ext.emptyFn,
    customSaveState: null,
    init: function(component) {
        var filterKey = this.filterKey;
        var onFilterLoaded = this.onFilterLoaded;
        var customSaveState = this.saveState;
        component.on(
            'afterlayout',
            function() {
                component.el.mask('loading');
                mx.data.Ajax.request({
                    method: 'GET',
                    url: mx.PATH + MXAT.API('filters/generic/get/' + filterKey),
                    success: function(resp) {
                        var reader = new mx.data.JsonReader(
                            {
                                totalProperty: 'total',
                                successProperty: 'success',
                                root: 'rows',
                            },
                            mx.data.ShipmentManagementFilter
                        );

                        var o = reader.read(resp);
                        if (o.success && o.records.length == 1) {
                            component.getForm().loadRecord(o.records[0]);
                            if (component.onRecordLoaded) {
                                component.onRecordLoaded(o.records[0]);
                            }
                        }
                        onFilterLoaded.call(component);
                        component.el.unmask();
                    },
                    failure: function() {
                        component.el.unmask();
                    },
                    scope: this,
                });
            },
            this,
            {single: true}
        );

        component.saveState = function(record, noCustom) {
            if (customSaveState && !noCustom) {
                return customSaveState.call(component);
            }
            if (record) {
                record.set('filterKey', filterKey);
                Ext.Ajax.request({
                    method: 'POST',
                    url: mx.PATH + MXAT.API('filters/generic/save/' + filterKey),
                    jsonData: record.getData(),
                });
            }
        };
    },
});
